import { PayNowModal } from 'components/account/pay-now/pay-now-modal';
import { withModal } from 'components/common/modal/withModal';
import { compose } from 'redux';

const enhance = compose(withModal);
const PayNowModalContainer = enhance(PayNowModal);

export { PayNowModalContainer };
